<div class="header">
  @if (isPrimary) {
    <p class="overline title">{{sysText.mergeDuplicates_primaryRecord}}</p>
  }
  @if (!isPrimary) {
    <p class="overline title">{{sysText.mergeDuplicates_secondaryRecord}}</p>
  }
  @if (employeeInfo.employee.image) {
    <img
      class="image-container"
      [src]="employeeInfo.employee.image"
      alt="">
  }
  @if (!employeeInfo.employee.image) {
    <div class="circle">
      {{ getInitials(employeeInfo.employee.description) }}
    </div>
  }
  <h5>{{employeeInfo.employee.description}}</h5>
  <p class="body2">{{employeeInfo.company.description}}</p>
</div>

<!-- Employee Info -->
<div class="section-header-container">
  <h2 class="overline grey1 semibold section-title">{{sysText.mergeDuplicates_employeeInfo}}</h2>
  <mat-divider class="section-header-underline"></mat-divider>
</div>
<div class="section-body">

  <p class="body2"><span class="semibold body-title">{{sysText.mergeDuplicates_fullName}}</span> {{employeeInfo.employee.description ?? '--'}}</p>
  <p class="body2"><span class="semibold body-title">{{sysText.mergeDuplicates_hasAccount}}</span> {{(employeeInfo.hasActivatedStiiraAccount == true ? sysText.yes : sysText.no)}}</p>

  <p class="body2 flex"><span class="semibold body-title">{{sysText.mergeDuplicates_externalIdentities}}</span>
  @if (employeeInfo.externalIdentities == null || employeeInfo.externalIdentities?.length == 0) {
    <span>--</span>
  } @else {
    <span>
      @for (exterrnalIdentity of employeeInfo.externalIdentities; track exterrnalIdentity) {
        <p class="external-identity">
          {{exterrnalIdentity.name + ": "}}
          {{exterrnalIdentity.identity}}
        </p>
      }
    </span>
  }
</p>

<p class="body2">
  <span class="semibold body-title">{{sysText.mergeDuplicates_workEmail}}
    @if (employeeInfo.primaryEmailIsPersonal == false) {
      <!-- a toggletip: "preferred" is its name and its tooltip -->
      <button
        type="button"
        class="button-reset toggletip star-button"
        [attr.aria-label]="sysText.mergeDuplicates_preferred"
        [matTooltip]="sysText.mergeDuplicates_preferred"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon>stars</mat-icon>
      </button>
    }
  </span>
  {{employeeInfo.workEmail ?? '--'}}
</p>
<p class="body2">
  <span class="semibold body-title">{{sysText.mergeDuplicates_personalEmail}}
    @if (employeeInfo.primaryEmailIsPersonal == true) {
      <button
        type="button"
        class="button-reset toggletip star-button"
        [attr.aria-label]="sysText.mergeDuplicates_preferred"
        [matTooltip]="sysText.mergeDuplicates_preferred"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon>stars</mat-icon>
      </button>
    }
  </span>
  {{employeeInfo.personalEmail ?? '--'}}
</p>
<p class="body2"><span class="semibold body-title">{{sysText.mergeDuplicates_workPhoneNumber}}</span> {{employeeInfo.workPhone ?? '--'}}</p>
<p class="body2"><span class="semibold body-title">{{sysText.mergeDuplicates_personalPhoneNumber}}</span> {{employeeInfo.personalPhone ?? '--'}}</p>

<p class="body2"><span class="semibold body-title">{{sysText.mergeDuplicates_workLocation}}</span> {{employeeInfo.workLocation ?? '--'}}</p>
<p class="body2"><span class="semibold body-title">{{sysText.mergeDuplicates_jobTitle}}</span> {{employeeInfo.jobTitle ?? '--'}}</p>
<p class="body2"><span class="semibold body-title">{{sysText.mergeDuplicates_workingInCity}}</span> {{employeeInfo.workingInCity ?? '--'}}</p>
<p class="body2"><span class="semibold body-title">{{sysText.mergeDuplicates_workingInState}}</span> {{employeeInfo.workingInState ?? '--'}}</p>

<p class="body2 flex"><span class="semibold body-title">{{sysText.mergeDuplicates_supervisors}}</span>
@if (employeeInfo.supervisors == null || employeeInfo.supervisors?.length == 0) {
  <span>--</span>
} @else {
  <span>
    @for (superv of employeeInfo.supervisors; track superv) {
      <p>{{superv.description}}</p>
    }
  </span>
}
</p>

<p class="body2"><span class="semibold body-title">{{sysText.mergeDuplicates_employmentStatus}}</span> {{employeeInfo.employmentStatus ?? '--'}}</p>
<p class="body2"><span class="semibold body-title">{{sysText.mergeDuplicates_employeeType}}</span> {{employeeInfo.employeeType ?? '--'}}</p>
<p class="body2"><span class="semibold body-title">{{sysText.mergeDuplicates_payType}}</span> {{employeeInfo.payType ?? '--'}}</p>

<p class="body2"><span class="semibold body-title">{{sysText.mergeDuplicates_hireDate}}</span> {{employeeInfo.hireDate ? (employeeInfo.hireDate | date) : '--'}}</p>
<p class="body2"><span class="semibold body-title">{{sysText.mergeDuplicates_originalHireDate}}</span> {{employeeInfo.originalHireDate ? (employeeInfo.originalHireDate | date) : '--'}}</p>
<p class="body2"><span class="semibold body-title">{{sysText.mergeDuplicates_lastTerminationDate}}</span> {{employeeInfo.lastTerminationDate ? (employeeInfo.lastTerminationDate | date) : '--'}}</p>

<p class="body2 flex"><span class="semibold body-title">{{sysText.mergeDuplicates_employeeSchedules}}</span>
@if (employeeInfo.workSchedules?.length == 0) {
  <span>--</span>
} @else {
  <span>
    @for (workSchedule of employeeInfo.workSchedules; track workSchedule) {
      <p>
        @if (workSchedule.effectiveDate) {
          {{(workSchedule.effectiveDate | date) + ": "}}
        }
        {{workSchedule.scheduleName ?? sysText.mergeDuplicates_irregularSchedule}}
      </p>
    }
  </span>
}
</p>
</div>

<!-- Leave Cases -->
<div class="section-header-container">
  <h2 class="overline grey1 semibold section-title">{{sysText.mergeDuplicates_leaveCases}}</h2>
  <mat-divider class="section-header-underline"></mat-divider>
</div>
@if (employeeInfo.leaveCases?.length > 0) {
  <div class="section-body">
    @for (case of employeeInfo.leaveCases; track case) {
      <p class="body2">
        <span class="semibold body-title">
          {{case.caseNumber}}
        </span>
        {{case.leaveType ? case.leaveType.description : sysText.mergeDuplicates_newRequest}}
        <span class="bullet-spacing">&bull;</span>
        {{case.currentStage}}
      </p>
    }
  </div>
}
@if (employeeInfo.leaveCases?.length == 0) {
  <div class="section-body">
    <p class="body2">{{sysText.mergeDuplicates_none}}</p>
  </div>
}

<!-- Leave Hours -->
<div class="section-header-container">
  <h2 class="overline grey1 semibold section-title">{{sysText.mergeDuplicates_leaveHours}}</h2>
  <mat-divider class="section-header-underline"></mat-divider>
</div>
<div class="section-body">
  <p class="body2">
    <span class="semibold body-title">
      {{employeeInfo.bank1Name}}
    </span>
    {{employeeInfo.bank1Hours?.totalHours ?? '--'}} {{sysText.mergeDuplicates_total}} / {{employeeInfo.bank1Hours?.availableHours ?? '--'}} {{sysText.mergeDuplicates_available}}
  </p>
  <p class="body2">
    <span class="semibold body-title">
      {{employeeInfo.bank2Name}}
    </span>
    {{employeeInfo.bank2Hours?.totalHours ?? '--'}} {{sysText.mergeDuplicates_total}} / {{employeeInfo.bank2Hours?.availableHours ?? '--'}} {{sysText.mergeDuplicates_available}}
  </p>
  <p class="body2">
    <span class="semibold body-title">
      {{employeeInfo.bank3Name}}
    </span>
    {{employeeInfo.bank3Hours?.totalHours ?? '--'}} {{sysText.mergeDuplicates_total}} / {{employeeInfo.bank3Hours?.availableHours ?? '--'}} {{sysText.mergeDuplicates_available}}
  </p>
  <p class="body2">
    <span class="semibold body-title">
      {{employeeInfo.bank4Name}}
    </span>
    {{employeeInfo.bank4Hours?.totalHours ?? '--'}} {{sysText.mergeDuplicates_total}} / {{employeeInfo.bank4Hours?.availableHours ?? '--'}} {{sysText.mergeDuplicates_available}}
  </p>
  <p class="body2">
    <span class="semibold body-title">
      {{employeeInfo.bank5Name}}
    </span>
    {{employeeInfo.bank5Hours?.totalHours ?? '--'}} {{sysText.mergeDuplicates_total}} / {{employeeInfo.bank5Hours?.availableHours ?? '--'}} {{sysText.mergeDuplicates_available}}
  </p>
</div>